class User {
  constructor (uid, userName, emailId, photoUrl) {
    this.uid = uid
    this.userName = userName
    this.emailId = emailId
    this.photoUrl = photoUrl
  }
}

export default User



// WEBPACK FOOTER //
// ./src/models/User.js